<!-- @if (backgroundImageMobile ?? backgroundImage) {
    <sirius-image-item
        [image]="backgroundImageMobile ?? backgroundImage | cast"
        [imageData]="imageData"
        objectFit="cover"
        objectPosition="bottom center"
        class="sir-image-mobile" />
} -->
@if (backgroundImageDesktop ?? backgroundImage) {
    <sirius-image-item
        [image]="backgroundImageDesktop ?? backgroundImage | cast"
        [imageData]="imageData"
        objectPosition="bottom right"
        objectFit="cover"
        [fluid]="true"
        class="sir-image-desktop" />
}
<sirius-container>
    @if (variant) {
        <div class="sir-text-container" [class.sir-text-context-on-dark]="variant === 'dark'">
            <div class="sir-text">
                <sirius-heading
                    [text]="title"
                    textStyleCategory="display"
                    textStyleSize="s"
                    data-cy="hero-heading"></sirius-heading>
                <ng-content> </ng-content>
            </div>
            @if (buttonPrimary || buttonSecondary) {
                <div class="sir-buttons">
                    @if (buttonPrimary) {
                        <a
                            siriusButton
                            [siriusLink]="buttonPrimary.link"
                            [iconName]="buttonPrimary.iconName"
                            [buttonText]="buttonPrimary.link.title"
                            [buttonType]="buttonType"
                            data-cy="hero-btn-primary"></a>
                    }
                    @if (buttonSecondary) {
                        <a
                            siriusButton
                            [size]="'small'"
                            [siriusLink]="buttonSecondary.link"
                            [iconName]="buttonSecondary.iconName"
                            [buttonText]="buttonSecondary.link.title"
                            [buttonType]="buttonType"
                            data-cy="hero-btn-secondary"></a>
                    }
                </div>
            }
        </div>
    }
</sirius-container>
